export const DefaultPropConfig = {
    String(d = '') {
        return {
            type: String,
            default: d,
        };
    },
    Object(d = {}) {
        return {
            type: Object,
            default: () => (d),
        };
    },
    Boolean(d = false) {
        return {
            type: Boolean,
            default: d,
        };
    },
    Array(d = []) {
        return {
            type: Array,
            default: () => (d),
        };
    },
};

export const dummy = 'dummy';
